import { render, staticRenderFns } from "./CustomerTicketTable.vue?vue&type=template&id=201afe54&scoped=true&"
import script from "./CustomerTicketTable.vue?vue&type=script&lang=js&"
export * from "./CustomerTicketTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTicketTable.vue?vue&type=style&index=0&id=201afe54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201afe54",
  null
  
)

export default component.exports